import React from 'react'

import {
  ProgramCardContainer,
  CardIcon,
  CardContent,
  ProgramTimings,
  ProgramName,
  EnrolLink,
  EnrolText
} from './styles'

const ProgramCard = ({ card, onCardClick }) => {
  const { name, timings, uuid, image } = card
  return (
    <ProgramCardContainer key={uuid} onClick={onCardClick}>
      <EnrolLink>
        <EnrolText>Enrol</EnrolText>
        <span className="fc-icon fc-icon-chevron-right"></span>
      </EnrolLink>
      <CardContent>
        {image && <CardIcon src={image} alt={name} />}
        <ProgramTimings>{timings}</ProgramTimings>
        <ProgramName>{name}</ProgramName>
      </CardContent>
    </ProgramCardContainer>
  )
}

export { ProgramCard }
